var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('About'),_c('hr',{staticClass:"container"}),_c('Tours'),_c('AdBanner',{attrs:{"backgroundImage":'banner-1.jpg'}}),_c('Places'),_c('hr',{staticClass:"container"}),_c('Blog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }